// extracted by mini-css-extract-plugin
export var hidden = "_ui-0";